var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full lg:max-w-lg"},[_c('div',{staticClass:"flex flex-col"},[_c('span',[_vm._v(_vm._s(_vm.activity.description))]),_c('span',{staticClass:"text-gray-400 italic"},[_vm._v(_vm._s(_vm.date))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }